import Client from 'graphql-client';

// TODO: need to detect when we're running in different environments, and
//       set host accordingly.
const host = 'https://venture-richmond.mblx.io';

export default Client({
  url: `${host}/graphql`,
  headers: {}
});



// WEBPACK FOOTER //
// ./src/util/graphql.js